import { Button, HStack, Heading, Stack, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import { Link as DefaultLink } from 'react-router-dom';
import { EmptyTable } from '../../components';
import React from 'react';
import { deliveryType } from '../../types';
import moment from 'moment';

type delivetyTableProps = {
    deliveries: Array<deliveryType>;
};

export const DeliveryTable = (props: delivetyTableProps) => {

    const { deliveries = [] } = props;

    return (
        <Stack bg={'#FFFFFF'} p={4} borderRadius={6} mt={3}>
            <HStack justifyContent={'space-between'}>
                <Heading size={'sm'} fontWeight={'semibold'}>Delivery</Heading>
                <Button size={'xs'} variant={'outline'} colorScheme={'yellow'} as={DefaultLink} to={'/deliveries'}>
                    View All
                </Button>
            </HStack>
            <Stack>
                <TableContainer>
                    <Table variant='simple'>
                        <Thead>
                            <Tr>
                                <Th>delivery id</Th>
                                <Th>full name</Th>
                                <Th>date and time</Th>
                                <Th>driver</Th>
                                <Th>truck</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                deliveries?.slice(0, 5)?.map((delivery: deliveryType, index: number) => (
                                    <Tr key={index}>
                                        <Td>{delivery?.delivery_id}</Td>
                                        <Td textTransform={'capitalize'}>{delivery?.customer_name}</Td>
                                        <Td>{moment(delivery?.date).format('YYYY-MM-DD')} | {delivery?.time}</Td>
                                        <Td textTransform={'capitalize'}>{delivery?.driver_name ?? '-'}</Td>
                                        <Td>{delivery?.truck_make ?? '-'}</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                    {!deliveries.length && <EmptyTable title='Oops!' description='Your company does not have deliveries.' />}
                </TableContainer>
            </Stack>
        </Stack>
    );
};